import { render, staticRenderFns } from "./myList.vue?vue&type=template&id=c5f2e0a6"
import script from "./myList.vue?vue&type=script&lang=ts"
export * from "./myList.vue?vue&type=script&lang=ts"
import style0 from "./myList.vue?vue&type=style&index=0&id=c5f2e0a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports